export default {
    // 下载地址
    dlbaseURL: 'https://online.meide-casting.com/meide', // 生产
    // dlbaseURL: 'https://online-test.meide-casting.com/meide', // 测试
    // dlbaseURL: 'https://online-dev.meide-casting.com/meide', // 开发
    // static开头的图片地址
    icoBaseUrl: 'https://online.meide-casting.com/mdfront/',   // 生产.
    // icoBaseUrl: 'https://online-test.meide-casting.com/mdfront/', // 测试
    // icoBaseUrl: 'https://online-dev.meide-casting.com/mdfront/', // 开发
}


